import Vue from 'vue'
import { axios } from '../util/request'

/**
 * 集团-到期日查询。
 * @param {*} factory
 */
export function getExpiringDate(companyDomain) {
	return axios({
		url: '/companyGroup/expiringDate?companyDomain=' + companyDomain,
		method: 'GET',
	})
}
